import type VueRouter from 'vue-router';

export default function bodyStyleGuard(router: VueRouter) {
  /**
   * 切换路由后设置body样式
   */
  router.afterEach((to) => {
    document.body.style.background = to.meta?.background ?? '#f8f9ff';
  });
}
